// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2uGlr","vLegacy":"SelectSecondary_vLegacy__JqLJu","error":"SelectSecondary_error__BtiAp","disabled":"SelectSecondary_disabled__MXnQs"};